document.addEventListener("click", function (e) {
  const lightbox = document.getElementById("menu-lightbox");
  if (!lightbox) return;

  function closeLightbox() {
    lightbox.hidden = true;
    document.documentElement.classList.remove("menu-no-scroll");
    if (window.menuSwiper) {
      window.menuSwiper.destroy(true, true);
      window.menuSwiper = null;
    }
  }

  function updateArrows() {
    const prevBtn = document.querySelector(".js-prev-image");
    const nextBtn = document.querySelector(".js-next-image");
    if (!window.menuSwiper || !prevBtn || !nextBtn) return;
    const total = window.menuSwiper.slides.length;
    const index = window.menuSwiper.activeIndex;
    prevBtn.hidden = total < 2 || index === 0;
    nextBtn.hidden = total < 2 || index === total - 1;
  }

  const openBtn = e.target.closest(".js-menu-open");

  if (openBtn) {
    const item = openBtn.closest(".menu-item");
    const detail = item ? item.querySelector(".menu-detail") : null;
    if (!detail) return;

    const slidesEl = document.getElementById("menu-lightbox-slides");
    const contentEl = document.getElementById("menu-lightbox-content");
    if (!slidesEl || !contentEl) return;

    const imgWrapper = detail.querySelector(".img-wrapper");
    slidesEl.innerHTML = imgWrapper ? imgWrapper.innerHTML : "";

    const blocks = detail.querySelectorAll(
      ".food-title, .menu-variants--lightbox, .food-ingrd, .food-options"
    );
    contentEl.innerHTML = Array.from(blocks).map(el => el.outerHTML).join("");

    lightbox.hidden = false;
    document.documentElement.classList.add("menu-no-scroll");

    if (window.menuSwiper) {
      window.menuSwiper.destroy(true, true);
      window.menuSwiper = null;
    }

    if (window.Swiper) {
      requestAnimationFrame(function () {
        window.menuSwiper = new Swiper(".menu-lightbox__slider", {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          pagination: {
            el: ".menu-lightbox__slider .swiper-pagination",
            clickable: true
          },
          observer: true,
          observeParents: true,
          on: {
            slideChange: updateArrows
          }
        });
        window.menuSwiper.update();
        updateArrows();
      });
    }

    return;
  }

  if (e.target.closest(".js-prev-image")) {
    e.preventDefault();
    e.stopPropagation();
    if (window.menuSwiper) window.menuSwiper.slidePrev();
    return;
  }

  if (e.target.closest(".js-next-image")) {
    e.preventDefault();
    e.stopPropagation();
    if (window.menuSwiper) window.menuSwiper.slideNext();
    return;
  }

  if (e.target.closest(".js-menu-close")) {
    closeLightbox();
    return;
  }

  if (!lightbox.hidden && e.target === lightbox) {
    closeLightbox();
  }
});

document.addEventListener("keydown", function (e) {
  const lightbox = document.getElementById("menu-lightbox");
  if (!lightbox) return;

  if (e.key === "Escape" && !lightbox.hidden) {
    lightbox.hidden = true;
    document.documentElement.classList.remove("menu-no-scroll");
    if (window.menuSwiper) {
      window.menuSwiper.destroy(true, true);
      window.menuSwiper = null;
    }
  }

  if (!lightbox.hidden) {
    if (e.key === "ArrowLeft" && window.menuSwiper) window.menuSwiper.slidePrev();
    if (e.key === "ArrowRight" && window.menuSwiper) window.menuSwiper.slideNext();
  }
});